import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { saveToGlobalState } from "../../utils/localStorage";

const API_URL = process.env.REACT_APP_API_URL;
const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;

export default function FacebookLoginButton() {
  const navigate = useNavigate();
  const btnRef = useRef(null);

  const { setShowLoginModal, setUser, setAccessToken } = useAuth();

  useEffect(() => {
    const loadFacebookSDK = () => {
      return new Promise((resolve) => {
        if (window.FB) {
          resolve();
          return;
        }

        const existing = document.getElementById("facebook-jssdk");

        if (existing) {
          existing.onload = resolve;
          return;
        }

        window.fbAsyncInit = function () {
          window.FB.init({
            appId: FACEBOOK_APP_ID,
            cookie: true,
            xfbml: false,
            version: "v22.0",
          });

          resolve();
        };

        const script = document.createElement("script");

        script.id = "facebook-jssdk";
        script.src = "https://connect.facebook.net/en_US/sdk.js";
        script.async = true;
        script.defer = true;

        document.body.appendChild(script);
      });
    };

    const init = async () => {
      await loadFacebookSDK();

      if (!window.FB || !btnRef.current) return;

      btnRef.current.onclick = () => {
        window.FB.login(
          (response) => {
            handleFacebookLogin(response);
          },
          {
            scope: "public_profile,email",
          },
        );
      };

      const handleFacebookLogin = async (response) => {
        if (!response.authResponse) return;

        try {
          const res = await fetch(`${API_URL}/api/auth/facebook/`, {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              access_token: response.authResponse.accessToken,
            }),
          });

          const data = await res.json();

          console.log("FACEBOOK BACKEND:", data);

          if (res.ok) {
            setAccessToken(data.access);
            setUser(data.user);
            setShowLoginModal(false);
            navigate("/dashboard");
            return;
          }

          if (data.redirect === "cadastro_facebook") {
            localStorage.setItem(
              "facebook_prefill",
              JSON.stringify(data.prefill),
            );

            navigate("/cadastro", {
              state: {
                ...data.prefill,
                facebook_incompleto: true,
              },
            });

            return;
          }

          if (data.redirect === "confirmacao_email") {
            saveToGlobalState({
              confirmation_token: data.confirmation_token,
            });

            setShowLoginModal(false);

            navigate("/confirmacao-email", {
              state: {
                email: data.email,
                telefone: data.telefone,
                phone_confirmation: data.phone_confirmation,
              },
            });

            return;
          }

          if (data.redirect === "confirmacao_telefone") {
            saveToGlobalState({
              confirmation_token: data.confirmation_token,
            });

            setShowLoginModal(false);

            navigate("/confirmacao-telefone", {
              state: {
                telefone: data.telefone,
              },
            });

            return;
          }

          if (data.code === "manual_account") {
            alert(data.detail);
            return;
          }

          alert(data.detail || "Erro ao fazer login com Facebook");
        } catch (err) {
          console.error("Erro login Facebook:", err);
        }
      };
    };

    init();
  }, [navigate, setAccessToken, setShowLoginModal, setUser]);

  return (
    <button ref={btnRef} type="button" className="facebook-login-button">
      <svg className="facebook-icon" viewBox="0 0 24 24" xmlns="http://w3.org">
        {/* Círculo de fundo branco */}
        <circle cx="12" cy="12" r="12" fill="#ffffff" />
        {/* O "F" em azul oficial */}
        <path
          d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
          fill="#1877F2"
        />
      </svg>
      <span className="facebook-text">Entrar com Facebook</span>
    </button>
  );
}
